import { ProposalIdItem } from 'features/globalSetup/types/gamOrderRetargetingDealsDelivery'

export const MAX_LINE_ITEMS = 150

export const calculateLineItems = ({
  max,
  min,
  step,
}: {
  max: ProposalIdItem['maxPrice']
  min: ProposalIdItem['minPrice']
  step: ProposalIdItem['step']
}): number => {
  if (step <= 0 || min >= max) {
    // handle NaN
    return 0
  }

  return Math.floor((max - min) / step) + 1
}
